import { h, ComponentChildren } from "preact";
import { useState } from "preact/hooks";
import SearchContext from "./SearchContext";

type providerProps = {
  children?: ComponentChildren;
};

function SearchProvider(props: providerProps) {
  const [searchString, setSearchString] = useState<string>("");

  return (
    <SearchContext.Provider value={{ searchString, setSearchString }}>
      {props.children}
    </SearchContext.Provider>
  );
}

export default SearchProvider;
